import { ChevronRight } from 'lucide-react';
import Link from "next/link";
import React from "react";
import { twMerge } from "tailwind-merge";

// const ButtonArrow = ({ link, txt, style }) => {
//   return (
//     <div className={twMerge(`relative text-slate-900 `, style)}>
//       <Link href={link}>
//         <div className="flex gap-0 hover:gap-2 ml-2 hover:tracking-wider duration-200 transition-all whitespace-nowrap tracking-wide text-xl xs:text-2xl pb-1 mt-7 font-medium  border-b-2 border-gray-500 cursor-pointer">
//           {txt}
//           <span aria-hidden="true" className="ml-2">
//             &rarr;
//           </span>
//         </div>
//       </Link>
//     </div>
//   );
// };

// export default ButtonArrow;

const ButtonArrow = ({ link, txt, style, btnStyle }) => {
  return (
    <div className={twMerge(`relative text-slate-900`, style)}>
      <Link href={link}>
        <div
          className={twMerge(
            "flex text-xl tracking-wide items-center mt-2 font-medium cursor-pointer hover:translate-x-1 hover:text-[#f1aa4e] duration-200 transition-all w-fit", btnStyle
          )}
        >
          {txt}
          <span aria-hidden="true" className="text-[#f1aa4e] sm:text-inherit">
           <ChevronRight />
          </span>
        </div>
      </Link>
    </div>
  );
};

export default ButtonArrow;
